import { Box } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import { HiOutlineVideoCamera } from "react-icons/hi2";

import { isVideoFormat } from "../IntroMediaUpload.utils";

type VideoThumbnailProps = {
  mediaUrl: string;
  format: string;
};

export const VideoThumbnail: React.FC<VideoThumbnailProps> = ({
  mediaUrl,
  format,
}) => {
  const thumbnailVideoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (isVideoFormat(format) && mediaUrl) {
      const video = thumbnailVideoRef.current;
      if (video) {
        video.currentTime = 0.01;
      }
    }
  }, [format, mediaUrl]);

  if (!isVideoFormat(format) || !mediaUrl) {
    return (
      <Box
        width="64px"
        height="64px"
        borderRadius="4px"
        bg="gray.100"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="gray.700"
      >
        <HiOutlineVideoCamera size={24} />
      </Box>
    );
  }

  return (
    <Box
      width="64px"
      height="64px"
      borderRadius="4px"
      bg="gray.100"
      overflow="hidden"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      color="gray.700"
    >
      <video
        ref={thumbnailVideoRef}
        src={mediaUrl}
        muted
        playsInline
        preload="metadata"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    </Box>
  );
};
